import { useState } from "react";
const baseURL =
  process.env.REACT_APP_BACKEND_URL || "https://api.connect.dalmlabs.com";
// window.location.hostname.includes("dev.")
//   ? "https://dev.api.connect.dalmlabs.com"
//   : "https://api.connect.dalmlabs.com";

export default function useRequest(
  endpoint: string,
  method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
  headers?: Record<string, any>
) {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<any>();
  const [statusCode, setStatusCode] = useState(0);
  const token = localStorage.getItem("authToken");

  async function makeRequest(
    data?: any,
    params?: Record<string, any>,
    pathParam?: string
  ) {
    setLoading(true);

    // URLSearchParams stringifies an `undefined`/`null` value as the literal
    // text "undefined"/"null" instead of dropping the key — e.g. a caller
    // passing `{ q: undefined, sender_id }` to omit an empty search query
    // ends up sending `?q=undefined&sender_id=...` for real, which several
    // search endpoints (e.g. Instagram's location search) then match zero
    // results against. Drop those keys instead of stringifying them.
    const cleanParams = Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v !== undefined && v !== null));
    const queryParams = new URLSearchParams(cleanParams).toString();
    const urlWithParams =
      pathParam && queryParams
        ? `${baseURL}${endpoint}/${pathParam}?${queryParams}`
        : pathParam
          ? `${baseURL}${endpoint}/${pathParam}`
          : queryParams
            ? `${baseURL}${endpoint}?${queryParams}`
            : `${baseURL}${endpoint}`;

    try {
      const isFormData = data instanceof FormData;

      const res = await fetch(urlWithParams, {
        method,
        headers: {
          ...(isFormData ? {} : { "Content-Type": "application/json" }),
          Authorization: `Bearer ${token}`,
          ...headers,
        },
        body:
          ["POST", "PUT", "DELETE", "PATCH"].includes(method) && data
            ? isFormData
              ? data
              : JSON.stringify(data)
            : undefined,
      });

      // A 204 (or any empty-bodied response — e.g. DELETE) has nothing for
      // res.json() to parse; it throws on an empty string, which used to
      // fall into the catch below and misreport a real success as a 500.
      let json: any = {};
      try {
        const text = await res.text();
        json = text ? JSON.parse(text) : {};
      } catch {
        json = {};
      }

      setResponse(json);
      setStatusCode(res.status);


      if (!res.ok) {
        // toast.error(json.message || "An error occurred, please try again");
      } else if (method !== "GET") {
        // toast.success(json.message || "Request successful");
      }

      setLoading(false);
      return [json, res.status];
    } catch (error: any) {
      setLoading(false);
      return [{}, 500];
    }
  }

  return { loading, makeRequest, response, statusCode };
}
